import React from "react";
import { Modal, Button } from "react-bootstrap";

const DrawingPadHelpInfoModal = ({ show, onHide }) => {
  return (
    <Modal
      style={{ zIndex: 9997 }}
      show={show}
      onHide={onHide}
      centered
      size="lg"
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.40rem" }}>
          How to Use the Drawing Pad
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ color: "#212529" }}>
        <ul style={{ paddingLeft: "1rem" }}>
          <li>
            <strong>Draw:</strong> Use your mouse or touch to draw. You can
            adjust the brush size and color.
          </li>
          <li>
            <strong>Clear:</strong> Clears the entire canvas.
          </li>
          <li>
            <strong>Save:</strong> Save your drawing as an image.
          </li>
          <li>
            <strong>Undo / Redo:</strong> Step backward or forward through your
            drawing actions.
          </li>
          <li>
            <strong>Add Text:</strong> Click <em>Add Text</em>, type your text
            in the field, customize the text size and color, then{" "}
            <u>
              click on the exact spot on the canvas where you want the text to
              appear
            </u>
            . Once done, click <em>Cancel Text</em> to return to drawing mode.
          </li>
          <li>
            <strong>Reference Images:</strong> Click on any image from the panel
            on the right, and it will appear on the canvas. Scroll to explore
            more reference images.
          </li>
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DrawingPadHelpInfoModal;
